/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';
import useImpactPriorities from './helper';
import DafTable from '../../../../components/Table/newTable';

export default function ImpactPriorities() {
  const { t } = useTranslation();
  const { filtersConfig, tabsConfig, columns } = useImpactPriorities();
  const data = useMemo(() => [], [tabsConfig]);

  return (
    <Widget
      className="with-border-header no-px-body overflow-hidden"
      title={t('Impact Priorities')}
      tabsConfig={tabsConfig}
    // filtersConfig={filtersConfig}
    >
      <Style>
        <div className='daf-table-wrapper pagination-w-padding no-pagination'>
          <DafTable
            data={data}
            pagination={data.length ? undefined : { pageSize: 8 }}
            doEmptyRows
            columns={columns}
            size="small"
            scroll={{ y: 340 }}
          />
        </div>
      </Style>
    </Widget>
  )
}
